import { render } from "./IconArrowRight.vue?vue&type=template&id=c1f679dc&scoped=true"
import script from "./IconArrowRight.vue?vue&type=script&lang=js"
export * from "./IconArrowRight.vue?vue&type=script&lang=js"

import "./IconArrowRight.vue?vue&type=style&index=0&id=c1f679dc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c1f679dc"

export default script